export const formatRejectionReasons = (
  selectedReasons,
  t,
  shouldAddPrefix = true,
) => {
  if (!selectedReasons || selectedReasons.length === 0) return "";

  const formattedReasons = selectedReasons
    .map((reason) => `• ${t(reason.title)}`)
    .join("\n");

  return `${shouldAddPrefix ? `${t("rejectedForTheFolloingReasons")}:\n\n` : ""}${formattedReasons}`;
};
